import * as React from "react";
import classes from "./Glossary.module.css";
import db from "../glosar.json";
import GlossarySection from "../components/GlossarySection/GlossarySection";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { createSlug, getUrlArrayFromChapter } from "../utils/utils";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Wrapper from "../components/Wrapper/Wrapper";
import { Helmet } from "react-helmet";
import VideoTextContainer from "../components/VideoTextContainer/VideoTextContainer";
import clsx from "clsx";

export interface ChildrenData {
  headline: string;
  body: string;
}

export interface Data {
  letter: string;
  children: [ChildrenData];
}

const data = Object.values(db.glossary);

const Glossary = () => {
  const [backToTop, setBackToTop] = React.useState(false);

  /* start of video hooks */
  const [url, setUrl] = React.useState("");
  const [playing, setPlaying] = React.useState(false);
  const [urlIndex, setUrlIndex] = React.useState(0);
  const [urlArray, setUrlArray] = React.useState<Array<string>>(
    getUrlArrayFromChapter([db.Introduction])
  );
  /* end of video hooks */

  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setBackToTop(true);
      } else {
        setBackToTop(false);
      }
    });
  }, []);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onParagraphClick = (url: string) => {
    if (url.length === 0 || url.slice(0, 7) === "NOMATCH") {
      return;
    }

    setUrl(url || ""); /* Set a placeholder instead */
    setPlaying(true);

    /* update URL index when user clicks on a paragraph */
    const foundIndex = urlArray.findIndex((i: string) => i === url);

    if (foundIndex === -1) {
      setUrlIndex(0);
    } else {
      setUrlIndex(foundIndex);
    }
  };

  const headline = (
    <div id={db.Introduction.headline}>
      <h2
        className={clsx(classes.headline, classes.clickable)}
        dangerouslySetInnerHTML={{ __html: db.Introduction.headline }}
        onClick={() => {
          onParagraphClick(db.Introduction.headline_url);
        }}
        style={{
          backgroundColor:
            db.Introduction.headline_url === url ? "white" : undefined,
        }}
      />
    </div>
  );

  return (
    <Wrapper background="rgb(240, 240, 240)">
      <Helmet>
        <title>Glosář</title>
      </Helmet>
      <Breadcrumbs />
      {headline}
      <VideoTextContainer
        chapterContent={[db.Introduction]}
        url={url}
        onParagraphClick={onParagraphClick}
        noVideo={false}
        urlArray={urlArray}
        urlIndex={urlIndex}
        setUrlIndex={setUrlIndex}
        playing={playing}
        setPlaying={setPlaying}
        setUrl={setUrl}
        foldableTables
      />

      <hr />

      <div className={classes.wrapper} style={{ paddingTop: "2rem" }}>
        <div className={classes.leftSide}>
          <div className={classes.leftSideContents}>
            <h3>Abecední seznam termínů</h3>
            {data.map((item: any) => {
              return (
                <ul key={item.letter}>
                  <li>
                    <Link
                      className={classes.link}
                      to={item.letter}
                      spy={true}
                      smooth={true}
                    >
                      {item.letter}
                    </Link>
                    {item.children.map((innerItem: ChildrenData) => {
                      return (
                        <ul key={innerItem.headline}>
                          <li className={classes.link}>
                            <Link
                              to={createSlug(innerItem.headline)}
                              spy={true}
                              smooth={true}
                            >
                              {innerItem.headline}
                            </Link>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              );
            })}
          </div>
        </div>

        <div className={classes.rightSide}>
          <div style={{ minHeight: "100vh" }}>
            {data.map((d, i) => (
              <GlossarySection key={i} data={d} />
            ))}
          </div>
        </div>
      </div>
      {backToTop && (
        <button className={classes.scrollToTop} onClick={scrollUp}>
          <FontAwesomeIcon icon={faArrowUp} /> Zpět
        </button>
      )}
    </Wrapper>
  );
};

export default Glossary;
